import React from 'react';
import { Navigate } from 'react-router-dom';
import 'swiper/css';
import RejectBottomSheet from '../../ui/RejectBottomSheet';
import SignBottomSheet from '../../ui/SignBottomSheet';
import Complete from '../../ui/Complete';
import PerButton from '../../ui/PerButton';
import UserInfo from '../../ui/UserInfo';
import Tabs from '../../ui/Tabs';
import BaseInfo from '../../ui/BaseInfo';
import CheckList from '../../ui/CheckList';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import Commons from '../../../../Services/Common/Common';
import DeletePermitBottomSheet from '../../ui/DeletePermitBottomSheet';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

export default function M_PER_BASIC_02(props) {
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  if (!props.rowData1) return <div>존재하지 않는 작업허가서입니다.</div>;
  if (props.isComplete)
    return (
      <Box sx={{ px: 2, height: '100%' }}>
        <Complete mode={props.mode} />
      </Box>
    );

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        gap: '16px',
      }}
    >
      {/* 작성자 정보 */}
      <UserInfo
        name={props.rowData1.NAME}
        userImg={props.rowData1.PHOTO}
        department={props.rowData1.DEP_NM_LAST}
        position={props.rowData1.POSITION}
      />

      {/* 탭 */}

      <Tabs
        activeIndex={props.activeIndex}
        setActiveIndex={props.setActiveIndex}
      />
      {/* 내용 */}
      <Box>
        {props.activeIndex === 0 && (
          // 기본작성정보
          <BaseInfo
            rowData1={props.rowData1}
            isChecked={props.isBaseChecked}
            setIsChecked={props.setIsBaseChecked}
          />
        )}
        {props.activeIndex === 1 && (
          // 작업별 사전 체크 항목
          <CheckList
            rowData1={props.rowData1}
            rowData2={props.rowData2}
            isChecked={props.isChecklistChecked}
            setIsChecked={props.setIsChecklistChecked}
            ConvertImageToBase64={props.ConvertImageToBase64}
          />
        )}
      </Box>
      {/* 반려-승인 버튼 */}
      {props.rowData1.GUBUN === '요청' ? (
        <PerButton
          onCancel={() =>
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'reject',
              })
            )
          }
          onClick={() => {
            if (!props.isBaseChecked && !props.isChecklistChecked) {
              props.setActiveIndex(0);
              dispatch(
                showSnackbar({
                  message: '확인 표시를 체크해주세요.',
                  type: 'warning',
                })
              );
              return;
            }
            if (!props.isBaseChecked) {
              props.setActiveIndex(0);
              dispatch(
                showSnackbar({
                  message: '기본 작성 정보를 확인하세요.',
                  type: 'warning',
                })
              );
              return;
            }
            if (!props.isChecklistChecked) {
              props.setActiveIndex(1);
              dispatch(
                showSnackbar({
                  message: '작업별 사전체크 항목을 확인하세요.',
                  type: 'warning',
                })
              );
              return;
            }
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'sign',
              })
            );
          }}
          cancelText="반려"
          cancelColor={'#FF6161'}
          saveText="승인"
        />
      ) : (
        <PerButton
          cancelText={'삭제'}
          saveText={'수정'}
          cancelColor={'#FF6161'}
          onCancel={() => {
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'delete',
              })
            );
          }}
          onClick={() => {
            props.setActiveStep(props.activeStep + 1);
            Commons.Storages('set', 'stepper', {
              step: props.activeStep + 1,
            });
            navigate(`/M_Permit/write/${props.rowData1.PM_CD}`);
          }}
        />
      )}
      {!props.rowData1 && <Navigate to="/M_Permit" replace />}
      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'reject' && (
        <RejectBottomSheet
          open={true}
          ToggleDrawer={props.ToggleDrawer}
          authorName={props.rowData1.NAME}
          SaveLogic1={props.SaveLogic1}
        />
      )}
      {bottomSheetState.bottom && bottomSheetState.type === 'sign' && (
        <SignBottomSheet
          open={true}
          ToggleDrawer={props.ToggleDrawer}
          authorName={props.rowData1.NAME}
          userInfo={props.userInfo}
          signatureCanvas={props.signatureCanvas}
          SaveLogic1={props.SaveLogic1}
          handleSignRequest={props.handleSignRequest}
          onComplete={() => props.setIsComplete(true)}
          setMode={props.setMode}
        />
      )}
      {bottomSheetState.bottom && bottomSheetState.type === 'delete' && (
        <DeletePermitBottomSheet
          open={true}
          ToggleDrawer={props.ToggleDrawer}
          DeleteLogic1={props.DeleteLogic1}
          title={'작업허가서를 삭제하시겠습니까?'}
        />
      )}
    </Box>
  );
}
